import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const isMac = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform);
const mod = isMac ? '⌘' : 'Ctrl';

const SHORTCUTS = [
  { section: '노트' },
  { keys: `${mod} + P`, desc: '빠른 열기 (Quick Open)' },
  { keys: `${mod} + N`, desc: '새 노트' },
  { keys: `${mod} + D`, desc: '노트 복제' },
  { keys: `${mod} + S`, desc: '노트 저장' },
  { keys: `${mod} + E`, desc: '.md로 내보내기' },
  { keys: `${mod} + ⇧ + P`, desc: '고정 / 해제' },
  { keys: 'Escape', desc: '선택 해제' },

  { section: '선택' },
  { keys: `${mod} + 클릭`, desc: '개별 선택' },
  { keys: '⇧ + 클릭', desc: '범위 선택' },

  { section: '에디터' },
  { keys: `${mod} + B`, desc: '굵게' },
  { keys: `${mod} + I`, desc: '기울임' },
];

const KeyboardShortcutsModal = ({ onClose }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="bear-dialog-overlay" onClick={onClose}>
      <div className="bear-dialog bear-shortcuts-dialog" onClick={e => e.stopPropagation()}>
        <div className="bear-shortcuts-header">
          <h3 className="bear-dialog-title" style={{ padding: 0 }}>키보드 단축키</h3>
          <button className="bear-shortcuts-close" onClick={onClose}>&times;</button>
        </div>
        <div className="bear-shortcuts-body">
          {SHORTCUTS.map((item, i) => {
            if (item.section) {
              return (
                <div key={i} className="bear-shortcuts-section">{item.section}</div>
              );
            }
            return (
              <div key={i} className="bear-shortcuts-row">
                <span className="bear-shortcuts-keys">
                  {item.keys.split(' + ').map((k, j) => (
                    <span key={j}>
                      {j > 0 && <span className="bear-shortcuts-plus">+</span>}
                      <kbd className="bear-kbd">{k}</kbd>
                    </span>
                  ))}
                </span>
                <span className="bear-shortcuts-desc">{item.desc}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default KeyboardShortcutsModal;
